(function iefe(w, d) {
    const nav = d.querySelector('.SideNav');
    const toggle = d.querySelector('.SideNav__toggle');
    const teststep = d.querySelector('.TestStep');
    const checkpoint = d.querySelector('.Checkpoint');

    const main = d.querySelector('main.Main');
    let mainminheight = 0;

    if (main) {
        mainminheight = main.clientHeight;
    }

    if (toggle) {
        toggle.addEventListener('click', () => {
            const exp = toggle.getAttribute('aria-expanded');
            toggle.setAttribute('aria-expanded', exp === 'true' ? 'false' : 'true');
            if (nav) {
                if (exp === 'true') {
                    nav.classList.remove('SideNav--open');
                } else {
                    nav.classList.add('SideNav--open');
                }
            }

            if (teststep) {
                if (exp === 'true') {
                    teststep.classList.remove('TestStep--open');
                } else {
                    teststep.classList.add('TestStep--open');
                }
            }

            if (checkpoint) {
                if (exp === 'true') {
                    checkpoint.classList.remove('Checkpoint--open');
                } else {
                    checkpoint.classList.add('Checkpoint--open');
                }
            }
        });
    }

    /* Adjust height of main-Element, so Nav doesnt overflow the page */
    function adjustHeight() {
        const navheight = nav.clientHeight;
        if (navheight - 50 > mainminheight) {
            main.style.minHeight = `${navheight - 50}px`;
        } else {
            main.style.minHeight = `${mainminheight - 50}px`;
        }
    }

    if (nav) {
        nav.addEventListener('click', () => {
            adjustHeight();
        });
    }
}(window, document));
